import { configureStore } from "@reduxjs/toolkit";
import appStateSlice from "./features/appStateSlice";
import userReducer from "./userSlice";
import dateReducer from "./dateSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    appState: appStateSlice,
    date: dateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["user/loginSuccess", "user/refreshTokensSuccess"],
        ignoredPaths: ["user.userDetails"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// import { configureStore } from "@reduxjs/toolkit";
// import appStateSlice from "./features/appStateSlice";
// import dateReducer from './dateSlice';
// import userReducer from './userSlice';

// export const store = configureStore({
//   reducer: {
//     appState: appStateSlice,
//     date: dateReducer,
//     user: userReducer,
//   }
// });

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
